import React, {useState} from "react";
import {
    Create,
    FormTab,
    TextInput,
    TabbedForm,
    Toolbar,
    ReferenceInput,
    NumberInput
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';


const useStyles = makeStyles((theme) => ({
    sexo_tipo: {display: 'inline-block', width: 200, marginLeft: 8},
}));

const PostCreateToolbar = props => {
    return (
        <Toolbar {...props} >

        </Toolbar>
    )

};

const validateCreate = (values) => {
    const errors = {};

    var w_sexo_tipo = values.sexo_tipo

    if (w_sexo_tipo===undefined) {
        errors.sexo_tipo = ['El campo Código es requerido'];
    }else {
        if (w_sexo_tipo === null) {
            errors.sexo_tipo = ['El campo Código es requerido'];
        } else {
            w_sexo_tipo = w_sexo_tipo.trim()
            if (w_sexo_tipo === '') {
                errors.sexo_tipo = ['El campo Código es requerido'];
            }
        }
    }


    return errors
};

// redirect to the related Author show page
const redirect = (basePath, id, data) => `/SexoTipo`;

const SexoTipoCreate = props => {
    const classes = useStyles();

    const PostTitle = ({record}) => {
        return <span>Alta de Sexo Tipo</span>;
    };

    return (
        <Create title={<PostTitle/>} {...props}>
            <TabbedForm
                // toolbar={<PostCreateToolbar />} validate={validateCreate} redirect={redirect}
            >
                {/*Datos*/}
                <FormTab label="DATOS SEXO TIPO">
                    <TextInput
                        label="Sexo Tipo"
                        source="sexo_tipo"
                        formClassName={classes.sexo_tipo}
                        placeholder="Ingrese Sexo Tipo"
                        helperText="Sexo Tipo"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />

                    <br/>

                </FormTab>
            </TabbedForm>
        </Create>
    )
};
export default SexoTipoCreate;


